enum DatePickerFieldActionType {
    DISPLAY_DATEPICKER_FIELD_ERROR = "DISPLAY_DATEPICKER_FIELD_ERROR",
    UPDATE_DATEPICKER_FIELD_VALUE = "UPDATE_DATEPICKER_FIELD_VALUE",
    RESET_DATEPICKER_FIELD = "RESET_DATEPICKER_FIELD",
}

export default DatePickerFieldActionType;
